export const ENTITY = 'STATISTIC';